import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { Card, CardMedia } from '../components/ds/Card';
import { Badge } from '../components/ds/Badge';
import { Reveal, PageHero } from '../components/ds/theme';
import sundaySchoolBg from '../assets/images/sunday_school_bg.jpg';
import { EVENTS_FEED_URL, decorateEvent } from '../lib/eventsMeta';

const ACCENTS = ['burgundy', 'navy', 'tan'];

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(EVENTS_FEED_URL)
      .then((r) => r.json())
      .then((data) => {
        setEvents((data.events || []).map(decorateEvent));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <main>
      <PageHero eyebrow="Mark Your Calendar" title="Events" subtitle="Join us for worship, fellowship, and community." image={sundaySchoolBg} />

      <section className="ds-section-y" style={{ background: 'var(--white)', padding: 'var(--section-y) var(--gutter)' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto' }}>
          {loading && (
            <div style={{ textAlign: 'center', color: 'var(--text-muted)', marginBottom: '24px', fontSize: '14px' }}>
              <Calendar size={14} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
              Loading the latest events…
            </div>
          )}
          {!loading && events.length === 0 && (
            <div style={{ textAlign: 'center', padding: '48px 16px', color: 'var(--text-muted)' }}>
              <Calendar size={40} style={{ opacity: 0.6, marginBottom: '12px' }} />
              <p style={{ fontFamily: 'var(--font-ui)', fontSize: '16px', margin: 0 }}>
                No upcoming events scheduled yet. Check back soon!
              </p>
            </div>
          )}
          <div className="ds-grid-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '34px' }}>
            {events.map((e, i) => (
              <Reveal key={e.id || e.title} delay={(i % 3) * 90}>
                <Link
                  to={`/events/${e.id}`}
                  style={{ display: 'block', height: '100%', textDecoration: 'none', color: 'inherit' }}
                >
                  <Card accent={ACCENTS[i % 3]} style={{ height: '100%', cursor: 'pointer' }} media={
                    <div style={{ position: 'relative' }}>
                      <CardMedia image={e.imageUrl} height="200px" />
                      <div style={{ position: 'absolute', left: '16px', top: '16px', width: '46px', height: '46px', borderRadius: 'var(--radius-md)', background: 'rgba(255,255,255,0.94)', color: 'var(--burgundy-700)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <e.Icon size={22} />
                      </div>
                    </div>
                  }>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px', flexWrap: 'wrap' }}>
                      <span style={{ fontFamily: 'var(--font-ui)', fontSize: '11.5px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.12em', color: 'var(--tan-700)' }}>{e.dateLabel}</span>
                      {e.recurring && <Badge tone="tan" soft>Recurring</Badge>}
                    </div>
                    <h3 className="v2-serif" style={{ fontSize: '24px', color: 'var(--navy-800)', margin: '0 0 10px', lineHeight: 1.2 }}>{e.title}</h3>
                    <p style={{ fontFamily: 'var(--font-ui)', fontSize: '15px', color: 'var(--text-body)', lineHeight: 1.68, margin: 0 }}>{e.description}</p>
                  </Card>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Events;
